export default "__VITE_ASSET__Dd58pTLY__"